import { l as e } from "./cart-surface-operations-DDPgeARZ.js";
var t = `Unable to add product`,
	n = 12e3,
	r = (e, n = t) => e?.description || e?.message || n,
	i = () => {
		let e = document.querySelector(`[data-cart-drawer]`);
		return e
			? {
					afterAddToCart:
						e.getAttribute(`data-after-add-to-cart`) || `cart_drawer`,
					cartType: e.getAttribute(`data-cart-type`) || `drawer`,
					sectionId: e.getAttribute(`data-section-id`) || ``,
				}
			: null;
	},
	a = (e) => {
		if (!(e instanceof HTMLFormElement) || e.closest(`[data-product-tile]`))
			return !1;
		let t = e.getAttribute(`action`) || ``;
		return e.hasAttribute(`data-product-form`) || t.includes(`cart/add`);
	},
	o = (e) =>
		e.afterAddToCart === `checkout`
			? `checkout`
			: e.cartType === `drawer`
				? `drawer`
				: e.afterAddToCart === `cart_page`
					? `cart_page`
					: (e.afterAddToCart, `drawer`),
	s = (e) => (e ? o(e) !== `cart_page` : !1),
	c = async (t, i, a) => {
		a === `drawer` &&
			i.sectionId &&
			(t.set(`sections`, i.sectionId),
			t.set(
				`sections_url`,
				`${window.location.pathname}${window.location.search}`,
			));
		let o = new AbortController(),
			s = window.setTimeout(() => o.abort(), n);
		try {
			let n = await fetch(`${e()}cart/add.js`, {
					method: `POST`,
					credentials: `same-origin`,
					headers: { Accept: `application/json` },
					body: t,
					signal: o.signal,
				}),
				a = await n.json();
			if (!n.ok) throw Error(r(a));
			return {
				addedItem: a,
				sectionHtml: a.sections?.[i.sectionId] || null,
				sectionId: i.sectionId,
			};
		} catch (e) {
			throw e instanceof DOMException && e.name === `AbortError`
				? Error(`Adding product timed out`)
				: e;
		} finally {
			window.clearTimeout(s);
		}
	},
	l = async (t, { onPending: n, openDrawer: r }) => {
		let a = i();
		if (!a) throw Error(`Cart drawer settings unavailable`);
		let s = o(a);
		n?.(!0);
		try {
			let n = await c(t, a, s);
			return s === `checkout`
				? ((window.location.href = `${e()}checkout`), n.addedItem)
				: s === `cart_page`
					? ((window.location.href = `${e()}cart`), n.addedItem)
					: (await r(n), n.addedItem);
		} finally {
			n?.(!1);
		}
	},
	u = async (e, t) => l(new FormData(e), t);
export { l as a, s as i, i as n, u as o, o as r, a as t };
